import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView
  }, 
  {
    path: '/home2',
    name: 'home2',
    component: () => import(/* webpackChunkName: "about" */ '../views/SixView.vue')
  }, 
  {
    path: '/home3',
    name: 'home3',
    component: () => import(/* webpackChunkName: "about" */ '../views/SixteenView.vue')
  },
  {
    path: '/page2',
    name: 'page2',
    component: () => import(/* webpackChunkName: "about" */ '../views/Page2View.vue')
  },
  {
    path: '/detail', 
    name: 'detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/DetailView.vue')
  },
  {
    path: '/detail2', 
    name: 'detail2',
    component: () => import(/* webpackChunkName: "about" */ '../views/Detail2View.vue')
  },
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/IndexView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode:'hash',
  routes
})

export default router
